import { useMutation } from "@tanstack/react-query";
import { HiverAxios } from '../../../../../common';
import { DEFAULT_TRIAL_EXTEND_DAYS } from "../constants/constants";

const extendUgTrialApi = async ({usergroupid, days=DEFAULT_TRIAL_EXTEND_DAYS}) => {
    return new Promise((resolve, reject) => {
        HiverAxios({
            url: `/account/extend-trial`,
            type: 'POST',
            params:{
                usergroupid,
                days,
                is_grexit_admin: 0
            },
            callback: response => resolve(response.data),
            onfail: error => reject(error),
        });
    });
};

export const useExtendUgTrialApi = () => {
  return useMutation({
    mutationFn: extendUgTrialApi,
  });
};